import {
  fetchDisplayOptionsRequest,
  fetchDisplayOptionsSuccess,
  fetchDisplayOptionsError,
} from 'AppSrc/core/components/forms/form-base-components/redux/display-options/actions-display-options';
import { currentSelectedNetwork } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { getApproverGroups, addApproverGroup } from './approvers-queries';

const FETCH_APPROVER_GROUPS_FOR_NETWORK_REQUEST = 'FETCH_APPROVER_GROUPS_FOR_NETWORK_REQUEST';
const FETCH_APPROVER_GROUPS_FOR_NETWORK_SUCCESS = 'FETCH_APPROVER_GROUPS_FOR_NETWORK_SUCCESS';
const FETCH_APPROVER_GROUPS_FOR_NETWORK_ERROR = 'FETCH_APPROVER_GROUPS_FOR_NETWORK_ERROR';
const ADD_APPROVER_GROUPS_TO_CRQ_REQUEST = 'ADD_APPROVER_GROUPS_TO_CRQ_REQUEST';
const ADD_APPROVER_GROUPS_TO_CRQ_SUCCESS = 'ADD_APPROVER_GROUPS_TO_CRQ_SUCCESS';
const ADD_APPROVER_GROUPS_TO_CRQ_ERROR = 'ADD_APPROVER_GROUPS_TO_CRQ_ERROR';
const ADD_SINGLE_APPROVER_GROUP_TO_CRQ_SUCCESS = 'ADD_SINGLE_APPROVER_GROUP_TO_CRQ_SUCCESS';

const fetchApproverGroupsForNetworkRequest = (network) => ({
  type: FETCH_APPROVER_GROUPS_FOR_NETWORK_REQUEST,
  payload: {
    network,
  },
});

const fetchApproverGroupsForNetworkSuccess = (network, groups) => ({
  type: FETCH_APPROVER_GROUPS_FOR_NETWORK_SUCCESS,
  payload: {
    network,
    groups,
  },
});

const fetchApproverGroupsForNetworkError = (network, error) => ({
  type: FETCH_APPROVER_GROUPS_FOR_NETWORK_ERROR,
  payload: {
    network,
    error,
  },
});

const addApproverGroupsToCrqRequest = (network, crqId) => ({
  type: ADD_APPROVER_GROUPS_TO_CRQ_REQUEST,
  payload: {
    network,
    crqId,
  },
});

const addApproverGroupsToCrqSuccess = (network, crqId) => ({
  type: ADD_APPROVER_GROUPS_TO_CRQ_SUCCESS,
  payload: {
    network,
    crqId,
  },
});

const addApproverGroupsToCrqError = (network, crqId, error) => ({
  type: ADD_APPROVER_GROUPS_TO_CRQ_ERROR,
  payload: {
    network,
    crqId,
    error,
  },
});

const addSingleApproverGroupToCrqSuccess = ({
  crqId,
  id,
  formFlow,
}) => ({
  type: ADD_SINGLE_APPROVER_GROUP_TO_CRQ_SUCCESS,
  payload: {
    crqId,
    id,
    formFlow,
  },
});

// FN: 20/01/2020:
// this isn't actually used at time of writing as we just use:
// fetchApproverGroupsForNetworkAsDisplayOptions
// for all of our current approver group needs
// thunk action for fetching approver groups
const fetchApproverGroupsForNetwork = (network) => (dispatch, getState) => {
  dispatch(fetchApproverGroupsForNetworkRequest(network));
  return getApproverGroups(network).then((groups) => {
    dispatch(fetchApproverGroupsForNetworkSuccess(network, groups));
  }).catch((error) => {
    dispatch(fetchApproverGroupsForNetworkError(network, error));
  });
};



const fetchApproverGroupsForNetworkAsDisplayOptions = (params) => (dispatch, getState) => {
  const {
    fieldId,
    network,
    preventRefresh,
  } = params;


  const state = getState();
  const currentDisplayOptions = state.displayOptions.displayOptionsDataById[fieldId];

  if (preventRefresh && currentDisplayOptions) {
    return Promise.resolve(null);
  }




  dispatch(fetchDisplayOptionsRequest(fieldId));


  return getApproverGroups(network)
    .then((groups) => {
      const displayOptions = groups;

      dispatch(fetchDisplayOptionsSuccess({
        fieldId,
        displayOptions,
      }));
    })
    .catch((error) => {
      dispatch(fetchDisplayOptionsError(fieldId, error));
    });
};

const addApproverGroupsToCrq = ({
  formData,
  approverGroups,
  formFlow,
}) => (dispatch, getState) => {
  const network = currentSelectedNetwork(formData);
  const { crqId } = formData;

  dispatch(addApproverGroupsToCrqRequest(network, crqId));
  const promises = approverGroups.map(({ id }) => addApproverGroup({
    id,
    network,
    crqId,
  }).then(() => {
    // dispatch an action to indicate we have successfully added this
    // approver group to the endpoint.
    // in the case of rasing a crq, we use this to update the value in redux
    // to readonly
    dispatch(addSingleApproverGroupToCrqSuccess({
      crqId,
      id,
      formFlow,
    }));
  }));
  return Promise.all(promises)
    .then(() => {
      dispatch(addApproverGroupsToCrqSuccess(network, crqId));
    }).catch((error) => {
      console.error(error);
      dispatch(addApproverGroupsToCrqError(crqId, network, error));
      return Promise.reject(error);
    });
};







export {
  fetchApproverGroupsForNetworkRequest,
  fetchApproverGroupsForNetworkSuccess,
  fetchApproverGroupsForNetworkError,
  FETCH_APPROVER_GROUPS_FOR_NETWORK_REQUEST,
  FETCH_APPROVER_GROUPS_FOR_NETWORK_SUCCESS,
  FETCH_APPROVER_GROUPS_FOR_NETWORK_ERROR,
  fetchApproverGroupsForNetwork,
  fetchApproverGroupsForNetworkAsDisplayOptions,
  addApproverGroupsToCrqRequest,
  addApproverGroupsToCrqSuccess,
  addApproverGroupsToCrqError,
  addApproverGroupsToCrq,
  ADD_APPROVER_GROUPS_TO_CRQ_REQUEST,
  ADD_APPROVER_GROUPS_TO_CRQ_SUCCESS,
  ADD_APPROVER_GROUPS_TO_CRQ_ERROR,
  ADD_SINGLE_APPROVER_GROUP_TO_CRQ_SUCCESS,
};
